module.exports = __webpack_public_path__ + "img/artistnight.30deed51.jpg";